import { useTracking } from '@change-corgi/core-react/tracking';

type Result = ModelHookResult<
	{
		primaryCtaUrl: string;
		secondaryCtaUrl: string;
	},
	{
		onPrimaryCtaClick: () => void;
		onSecondaryCtaClick: () => void;
	}
>;

export function useFinalCta(): Result {
	const track = useTracking();

	const primaryCtaUrl = '/nonprofit/claim/search?source=nonprofit-lp';
	const secondaryCtaUrl = 'mailto:npo@change.org';

	return {
		actions: {
			onPrimaryCtaClick: () => {
				void track('nonprofit_start_petition_click', { source_location: 'final_cta' });
			},
			onSecondaryCtaClick: () => {
				void track('nonprofit_talk_to_team_click', { source_location: 'final_cta' });
			},
		},
		data: {
			primaryCtaUrl,
			secondaryCtaUrl,
		},
	};
}
